import React from 'react';

import './PaneHeader.scss';
import { APP_TITLE_PREFIX } from 'RLX/Config';

class PaneHeader extends React.Component {
  constructor (props) {
    super(props);
    this.applyTitleToDocument = this.applyTitleToDocument.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentDidUpdate = this.componentDidUpdate.bind(this);
  }

  applyTitleToDocument () {
    if (!this.props.title || !this.titleNode) return;
    const pageTitle = this.titleNode.innerText;
    document.title = APP_TITLE_PREFIX + pageTitle;
  }

  componentDidMount () {
    this.applyTitleToDocument();
  }

  componentDidUpdate () {
    this.applyTitleToDocument();
  }

  render () {
    const { title, children } = this.props;
    return (
      <div className="PaneHeader">
        {!title ? null : (
          <h1 className={'PaneTitle' + (typeof title === 'object' || title.length  ? '' : ' empty')} ref={(node) => this.titleNode = node}>
            {title}
          </h1>
        )}
        {!children ? null : (
          <div className="PaneChildren">
            {children}
          </div>
        )}
      </div>
    );
  }
};

export default PaneHeader;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/Common/PaneHeader/PaneHeader.jsx